"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalAutoFocus = void 0;
const react_1 = require("react");
/**
 * This hook serves as a shortcut for manually controlling either open or close
 * autofocus behaviour on the Modal component.
 *
 * @returns
 * - A `ref` object passed as the ref attribute of the element to focus on
 * - A `handleFocusRef` function that gets passed as one of the Modal autofocus handlers
 */
const useModalAutoFocus = () => {
    const ref = (0, react_1.useRef)(null);
    const handleFocusRef = (e) => {
        var _a;
        e.preventDefault();
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return { ref, handleFocusRef };
};
exports.useModalAutoFocus = useModalAutoFocus;
//# sourceMappingURL=useModalAutoFocus.js.map